import { post } from "~/api2/utils/requests"

export interface CamperImportResult {
  created: {
    row: number
    camper_id: string
    first_name: string
    last_name: string
    email: string
  }[]
  errors: {
    row: number
    message: string
    first_name: string
    last_name: string
    email: string
  }[]
}

const importCsv = (campId: string, file: File): Promise<CamperImportResult> =>
  post(`/api/onboarding/campers/csv_import?camp_id=${campId}`, file, {
    headers: { "Content-Type": "text/csv" },
  }) as Promise<CamperImportResult>

const CamperImport = { importCsv }
export default CamperImport
export type { CamperImportResult }
